// load the inline styles
var inlineCss = ".te-pro-gallery-text-item{font:;{{Body-S}};color:{{color-1}}}.gallery-item-wrapper-text .gallery-item-content{background-color:{{color-5}}}.cart-icon{font:;{{style.cartIconFont font_8}};color:{{style.cartIconFontColor color-8}}}";
require("!../../../../../../node_modules/wix-tpa-style-loader/dist/src/addStyles.js")(inlineCss);
if(module.hot) {
  module.hot.accept();
  if(document.querySelector('style[hot-reloaded]') && window.Wix) {
    window.Wix.Styles.getStyleParams(function(style){
      window.postMessage(JSON.stringify({intent: 'addEventListener', eventType:window.Wix.Events.STYLE_PARAMS_CHANGE, params:{style: style}}), '*')
    })
  }
}